<template>
  <svg
    width="23"
    height="14"
    viewBox="0 0 23 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M0 0H22.8421V14H0V0Z" fill="white" />
    <path d="M0 4.78906H22.8421V9.21011H0V4.78906Z" fill="#1E50A0" />
    <path
      d="M0 12.1579H22.8421V14H0V12.1579ZM0 0H22.8421V1.84211H0V0Z"
      fill="#D22F27"
    />
  </svg>
</template>
